export default __webpack_public_path__ + "static/media/NoResults-mobile.327d354f.svg";